import React, { useState } from "react";
import { AiOutlineLike, AiFillLike } from "react-icons/ai";
import { FaRegCommentDots } from "react-icons/fa6";
import { Modal, Button, Spinner } from "react-bootstrap";
import PropTypes from "prop-types";

import {
  createAnnouncementAction,
  getPublishedAnnouncements,
  fetchAnnouncementComments,
  addAnnouncementComment
} from "../../../redux/slice/announcementsSlice";

import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CrossIcon from "../../../assets/img/file-cut-icon.png";

export default function AnnouncementAction({ item }) {
  const dispatch = useDispatch();
  const { commentsData = {}, commentsLoading = false } = useSelector((state) => state?.announcements || {});

  const [showComments, setShowComments] = useState(false);
  const [commentText, setCommentText] = useState("");

  const likeCount = item?.likeCount
    ? Object.keys(item.likeCount).length
    : 0;

  const commentCount = item?.commentCount??0;

  /* BAD WORD FILTER */
  const bannedWords = ["sex", "fuck", "bitch", "asshole"];

  const containsBannedWords = (text = "") => {
    const lowerText = text.toLowerCase();
    return bannedWords.some((word) =>
      lowerText.includes(word)
    );
  };

  const openCommentsModal = () => {
    if (!item?.id) return;
    setShowComments(true);
    dispatch(
      fetchAnnouncementComments({
        id: item.id,
        page: 0,
        size: 20
      })
    );
  };

  const handleCommentChange = (e) => {
    const value = e.target.value;
    if (containsBannedWords(value)) {
      toast.error("Inappropriate word detected");
      return;
    }
    setCommentText(value);
  };

   const handleAddComment = async () => {
    if (!commentText.trim()) {
      toast.error("Comment cannot be empty");
      return;
    }

    if (containsBannedWords(commentText)) {
      toast.error("Your comment contains inappropriate language");
      return;
    }

    try {
      await dispatch(
        addAnnouncementComment({
          id: item.id,
          comment: commentText
        })
      ).unwrap();
      toast.success("Comment added");
      setCommentText("");
      dispatch(
        fetchAnnouncementComments({
          id: item.id,
          page: 0,
          size: 20
        })
      );

      dispatch(
        getPublishedAnnouncements({
          page: "0",
          size: "10"
        })
      );

    } catch (err) {
      console.error(err);
      toast.error(err?.message || "Failed to add comment");
    }
  };

  const handleAction = async () => {
    try {
      await dispatch(
        createAnnouncementAction({ id: item.id })
      ).unwrap();
      dispatch(
        getPublishedAnnouncements({
          page: "0",
          size: "10"
        })
      );

    } catch (err) {
      console.error(err);
      toast.error(err?.message || "Announcement action failed");
    }
  };

  let commentsContent;
  if (commentsLoading) {
    commentsContent = (
      <div className="text-center">
        <Spinner animation="border" size="sm" />
      </div>
    );
  } else if (commentsData?.content?.length) {
    commentsContent = commentsData.content.map((comment) => (
      <div key={comment.id} className="mb-3 border-bottom pb-2">
        <div className="fw-bold d-flex justify-content-between">
          <span>{comment.employeeName}</span>
          <small className="text-muted">
            {new Date(comment.createdAt).toLocaleString()}
          </small>
        </div>
        <div>{comment.comment}</div>
      </div>
    ));
  } else {
    commentsContent = (
      <p className="text-muted text-center">
        -- No comments --
      </p>
    );
  }
  return (
    <>
      <div className="d-flex announcement-actions">

       <button
          type="button"
          className={`btn-interactive like-btn ${
            item?.likedByCurrentUser ? "active" : ""
          }`}
          onClick={handleAction}
        >
          {item?.likedByCurrentUser ? (
            <AiFillLike className="liked" />
          ) : (
            <AiOutlineLike className="unliked" />
          )}

          {likeCount > 0 && (
            <span className="count-badge">{likeCount}</span>
          )}

          <span className={likeCount > 0 ? "ml-4" : "ml-1"}>
            {likeCount === 1 ? "Like" : likeCount > 1 ? "Likes" : "Like"}
          </span>
        </button>

        <button
          type="button"
          className="btn-interactive like-btn"
          onClick={openCommentsModal}
        >
          <FaRegCommentDots className="unliked" />
          {commentCount > 0 && (
            <span className="count-badge">{commentCount}</span>
          )}
          <span className={commentCount > 0 ? "ml-4" : "ml-1"}>
            {commentCount === 1
              ? "Comment"
              : commentCount > 1
              ? "Comments"
              : "Comment"}
          </span>
        </button>
      </div>

      {showComments && (
        <Modal
          key={item?.id}
          show={showComments}
          onHide={() => setShowComments(false)}
          size="lg"
          centered
          className="announcements-view-comments"
        >
          <Modal.Header>
            <Modal.Title>
              Comments ({commentsData?.totalElements || 0})
            </Modal.Title>
            <button
              onClick={() => setShowComments(false)}
              className="modal-close"
              >
                <img
                  src={CrossIcon}
                  alt="Close"
                  style={{ width: "20px", height: "20px" }}
                />
              </button>
          </Modal.Header>
          <Modal.Body
            style={{
              maxHeight: "400px",
              overflowY: "auto"
            }}
          >
            {commentsContent}
          </Modal.Body>
          <Modal.Footer>
            <input
              type="text"
              className="form-control"
              placeholder="Write a comment..."
              value={commentText}
              onChange={handleCommentChange}
            />
            <Button
              variant="primary"
              className="primary-btn ml-4 mt-0 pl-4 pr-4"
              onClick={handleAddComment}
            >
              Add Comment
            </Button>
          </Modal.Footer>
        </Modal>
      )}

    </>
  );
}

AnnouncementAction.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    likeCount: PropTypes.object,
    commentCount: PropTypes.object,
    likedByCurrentUser: PropTypes.bool
  }).isRequired
};